import React, {Suspense} from 'react';
import { Route } from 'react-router-dom';

const ArticleContracts = React.lazy(() => import('./index'));
const ArticleContractTable = React.lazy(() => import('./articleContractTable'));
const ArticleContract = React.lazy(() => import('./articleContract'));
const ArticleContractDetail = React.lazy(() => import('./articleContractDetail'));
const AddNewArticleContract = React.lazy(() => import('./addNewArticleContract'));
const EditArticleContract = React.lazy(() => import('./editArticleContract'));

export const useArticleContractRoutes = () => {

    return (
        <Route path="articleContracts" element={<Suspense fallback={<div>منتظر باشید...</div>}><ArticleContracts /></Suspense>} >
            <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><ArticleContractTable/></Suspense> } />
            <Route path="new" element={<Suspense fallback={<div>منتظر باشید...</div>}><AddNewArticleContract/></Suspense> } />
            <Route path=":recordId" element={<Suspense fallback={<div>منتظر باشید...</div>}><ArticleContract/></Suspense> } >
                <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><ArticleContractDetail/></Suspense> } />
                <Route path="edit" element={<Suspense fallback={<div>منتظر باشید...</div>}><EditArticleContract/></Suspense> } />
            </Route>
        </Route>
    )
}